

var _angular = require('angular');

var _squid = require('squid');

var _fi = require('xo-models/src/fi');

var _logger = require('xo-beaver/dist/logger');

var _user = require('xo-models/src/user');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

var _uiRouter = require('uiRouter');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedFactory', function () {

    var state = {
        reviewTopupErrorMessage: {},
        tokenizationFlags: {
            sepaAgree: false
        }
    };

    var get = function get() {
        return state;
    };

    var AUTHORIZE_AND_UPDATE_SCOPE_BATCH = 'authorizeAndUpdateScope';
    var AUTHORIZE_CALL = 'authorize';

    /**
     * PatchXO api call for tokenization flows
     */
    var tokenizationPatchXO = function tokenizationPatchXO(checkoutSession, instrumentId) {
        return checkoutSession.action('setTopupFI', {
            data: {
                instrument_id: instrumentId
            }
        });
    };

    /**
     * Agree Sepa Mandate:
     *  When user has clicked on the checkbox, call SepaAccept api, then calls PatchXO
     *  When user has not clicked on the checkbox, show page level error message
     */
    var agreeSepaMandate = function agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel) {
        if (checkoutCart.isWalletTokenization()) {
            var bankId = checkoutSession.get('sepa_mandate.bankId');
            if (bankId && state.tokenizationFlags.sepaAgree) {
                // User agreed to the Sepa mandate by clicking on the checkbox
                return _fi.$SepaModel.instance().action('sepaAccept', {
                    data: {
                        bank: {
                            id: bankId
                        }
                    },
                    success: function success() {
                        // Patch XO after Sepa agreed by user, so as to update PAPS
                        return tokenizationPatchXO(checkoutSession, bankId);
                    }
                });
            } else if (bankId) {
                // User did not agree to the Sepa mandate
                var msg = (0, _squid.$renderContent)('tokenization.agreeToSepaMsg', {
                    type: tokenizedWalletInfoModel.brandName()
                });

                state.reviewTopupErrorMessage = {
                    msgs: [msg],
                    type: 'warning'
                };
                return _angular.$q.reject();
            }
        }
        return _angular.$q.when();
    };

    /**
     * Save the pin when its available
     */
    var setTokenizedWalletPin = function setTokenizedWalletPin(walletPinModel) {
        if (walletPinModel) {
            var pinModel = {
                data: {
                    pin: walletPinModel.userPin
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'TopUp_REVIEW',
                            'to': 'process_review',
                            'context_id': _angular.$rootScope.token,
                            'context_type': 'BA-Token',
                            'billing_token': _squid.$meta.baToken,
                            'int_error_code': 'pin_setup_contingencies',
                            'int_error_description': err,
                            'error_source': 'issuancemanagementserv'
                        });

                        throw err;
                    }
                }
            };

            if (walletPinModel.isSetupEligible()) {
                if (walletPinModel.isPinIdPresent()) {
                    pinModel.data.pinId = walletPinModel.getPinId();
                }
                return walletPinModel.save(pinModel);
            }
        }
        return _angular.$q.when();
    };

    var tokenizedOnPayCalls = function tokenizedOnPayCalls(checkoutCart, checkoutSession, tokenizedWalletInfoModel, walletPinModel) {
        return agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel).then(function () {
            return setTokenizedWalletPin(walletPinModel);
        });
    };

    /**
     * log FPTI event after authorize or authorizeAndUpdateScope call
     */
    var logProcessReviewToFPTI = function logProcessReviewToFPTI() {
        var _$WalletPreferences$i = _fi.$WalletPreferences.instance(_angular.$rootScope.token),
            _$WalletPreferences$i2 = _$WalletPreferences$i.topup,
            topup = _$WalletPreferences$i2 === undefined ? {} : _$WalletPreferences$i2,
            _$WalletPreferences$i3 = _$WalletPreferences$i.direct,
            direct = _$WalletPreferences$i3 === undefined ? {} : _$WalletPreferences$i3,
            currency = _$WalletPreferences$i.currency;

        _logger.$logger.info('tokenized_wallet', {
            'from': 'TopUp_REVIEW',
            'to': 'process_review',
            'topup_amt': topup.amount,
            'chosen_topup_fi': topup.fundingSource && topup.fundingSource.type,
            'chosen_direct_fi': direct.fundingSource && direct.fundingSource.type,
            'currency_code': currency || topup.currency,
            'context_id': _angular.$rootScope.token,
            'context_type': 'BA-Token',
            'billing_token': _squid.$meta.baToken
        });
    };

    /**
     * Update user's scope with "issuance" scope for Google account linking flow
     * Call must be triggered only after successfull "authorize" call
     *
     * If successfull - redirect back to success url
     *
     * If there is a contingency (UAL_ISSUANCE_UPDATE_SCOPE_ERROR) - go to default tokenized wallet error page (see public/js/lib/contingency.js)
     *
     * To improve latency - batch it with "authorize" call
     */
    var updateIssuanceScope = function updateIssuanceScope() {
        var authConsentModel = _user.$AuthConsentModel.instance();

        return authConsentModel.action('updateIssuanceScope', {
            batch: {
                name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
                id: 'updateIssuanceScope',
                dependencies: [AUTHORIZE_CALL]
            },
            data: {
                'ba_token': _squid.$meta.baToken
            },
            success: function success() {
                _logger.$logger.info('ual_update_issuance_scope_success');
                logProcessReviewToFPTI();

                return _uiRouter.$state.go('checkout.end');
            }
        });
    };

    /**
     * Check if flow is Google account linking
     */
    var isGoogleAccountLinking = function isGoogleAccountLinking() {
        var checkoutCart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var auth = _auth.$AuthModel.instance();

        return checkoutCart.isWalletTokenization() && auth.logged_in && auth.disallow_login_switch;
    };

    /**
     * Construct batch object for "authorize" call
     */
    var getAuthorizeBatch = function getAuthorizeBatch() {
        return {
            name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
            id: AUTHORIZE_CALL,
            dependencies: []
        };
    };

    return {
        get: get,
        agreeSepaMandate: agreeSepaMandate,
        setTokenizedWalletPin: setTokenizedWalletPin,
        tokenizedOnPayCalls: tokenizedOnPayCalls,
        updateIssuanceScope: updateIssuanceScope,
        isGoogleAccountLinking: isGoogleAccountLinking,
        logProcessReviewToFPTI: logProcessReviewToFPTI,
        getAuthorizeBatch: getAuthorizeBatch
    };
});

_angular.$q;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_fi.$SepaModel;

_logger.$logger;

_user.$AuthConsentModel;

_auth.$AuthModel;

_fi.$WalletPreferences;

_checkout.$CheckoutCartModel;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/tokenizedFactory.js
// module id = ./pages/xo-review/tokenizedFactory.js
// module chunks = 0